module.exports = __webpack_public_path__ + "img/Z86Q_06.90e286c4.jpg";